


/**/

document.addEventListener('DOMContentLoaded', function() {
  const detailsElement = document.getElementById('Details-HeaderMenu-1');
  const mainContent = document.getElementById('MainContent');

  if (detailsElement && mainContent) {
    detailsElement.addEventListener('toggle', function() {
      if (detailsElement.hasAttribute('open')) {
        mainContent.classList.add('menu-open');
      } else {
        mainContent.classList.remove('menu-open');
      }
    });
  }
});





/**/

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  
  const animationTimeline = gsap.timeline();

  const textAnimations = [
    '.letter-t',
    '.letter-o-first',
    '.letter-k',
    '.letter-n-first',
    '.letter-o-second',
    '.letter-w',
    '.letter-n-last'
  ];

  textAnimations.forEach((selector) => {
    animationTimeline.set(selector, { y: '-200%', zIndex: 15 });
  });

  animationTimeline.set('.hero-content', { opacity: 0, zIndex: 20 });
  animationTimeline.set('.horizontal-product-gallery', { opacity: 0, zIndex: 20 });

  animationTimeline
    .to('.letter-t', { y: '50%', duration: 0.8 })
    .to('.letter-w', { y: '50%', duration: 0.8 }, '-=0.5')
    .to('.letter-n-first', { y: '50%', duration: 0.8 }, '-=0.4')
    .to('.letter-n-last', { y: '50%', duration: 0.8 }, '-=0.5')
    .to('.letter-o-first', { y: '70%', duration: 0.8 }, '-=0.4')
    .to('.letter-k', { y: '50%', duration: 0.8 }, '-=0.5')
    .to(textAnimations, {
      y: '0%',
      duration: 1,
      ease: 'elastic.out(1, 0.5)',
    }, '-=0.25')
    .to('.letter-wrapper', {
      y: '0%',
      duration: 0.35,
      ease: 'power4.inOut',
    }, '-=1.1')
    .to('.hero-content', {
      opacity: 1,
      duration: 1,
      ease: 'power2.inOut',
    }, '-=0.5')
    .to('.horizontal-product-gallery', {
      opacity: 1,
      duration: 0.5,
      ease: 'power2.inOut',
    }, '-=0.5');




/*----- MOBILE TEXT ANIMATION ------*/

  if (window.innerWidth < 749) {
    const animationTimeline = gsap.timeline();

    const textAnimations = [
      '.letter-t',
      '.letter-o-first',
      '.letter-k',
      '.letter-n-first',
      '.letter-o-second',
      '.letter-w',
      '.letter-n-last'
    ];

    textAnimations.forEach((selector) => {
      animationTimeline.set(selector, { y: '-200%', zIndex: 15 });
    });

    animationTimeline.set('.hero-content', { opacity: 0, zIndex: 20 });
    animationTimeline.set('.horizontal-product-gallery', { opacity: 0, zIndex: 20 });

    animationTimeline
      .to('.letter-t', { y: '50%', duration: 0.8 })
      .to('.letter-w', { y: '50%', duration: 0.8 }, '-=0.5')
      .to('.letter-n-first', { y: '50%', duration: 0.8 }, '-=0.4')
      .to('.letter-n-last', { y: '50%', duration: 0.8 }, '-=0.5')
      .to('.letter-o-first', { y: '70%', duration: 0.8 }, '-=0.4')
      .to('.letter-k', { y: '50%', duration: 0.8 }, '-=0.5')
      .to(textAnimations, {
        y: '0%',
        duration: 1,
        ease: 'elastic.out(1, 0.5)',
      }, '-=0.25')
      .to('.letter-wrapper', {
        y: '10%',
        duration: 0.35,
        ease: 'power4.inOut',
      }, '-=1.1')
      .to('.hero-content', {
        opacity: 1,
        duration: 1,
        ease: 'power2.inOut',
      }, '-=0.5')
      .to('.horizontal-product-gallery', {
        opacity: 1,
        duration: 0.5,
        ease: 'power2.inOut',
      }, '-=0.5');


    
  }

  


/*----- BLUR AND FADE OUT SECTION AFTER GALLERY -----*/
  gsap.to(".fade-out-section .ss-content-wrapper", {
    scrollTrigger: {
      trigger: ".fade-out-section",
      start: "50% 15%",
      end: "bottom top", 
      scrub: true,
      markers: false, 
    },
    filter: "blur(10px)",
    opacity: 0,
    ease: "none",
  });
  




/*----- PRODUCTS SCROLL INTO PLACE -----*/
  gsap.to('.product-one', {
    scrollTrigger: {
      trigger: '#shopify-section-template--24042611966238__power_section_RCBAqi .ss-content-wrapper',
      start: 'top top',
      end: 'bottom bottom',
      scrub: 2,
      markers: false,
    },
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0,
    duration: 1
  });

  gsap.to('.product-two', {
    scrollTrigger: {
      trigger: '#shopify-section-template--24042611966238__power_section_RCBAqi .ss-content-wrapper',
      start: 'top top',
      end: 'bottom bottom',
      scrub: 2,
      markers: false,
    },
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0,
    duration: 1
  });

  gsap.to('.product-three', {
    scrollTrigger: {
      trigger: '#shopify-section-template--24042611966238__power_section_RCBAqi .ss-content-wrapper',
      start: 'top top',
      end: 'bottom bottom',
      scrub: 2,
      markers: false,
    },
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0,
    duration: 1
  });

 
  if (window.innerWidth < 749) {
  gsap.to('.product-one', {
    scrollTrigger: {
      trigger: '#shopify-section-template--24042611966238__power_section_RCBAqi .ss-content-wrapper',
      start: 'top top',
      end: '70% bottom',
      scrub: 2,
      markers: false,
    },
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0,
    duration: 1
  });

  gsap.to('.product-two', {
    scrollTrigger: {
      trigger: '#shopify-section-template--24042611966238__power_section_RCBAqi .ss-content-wrapper',
      start: 'top top',
      end: '70% bottom',
      scrub: 2,
      markers: false,
    },
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0,
    duration: 1
  });

  gsap.to('.product-three', {
    scrollTrigger: {
      trigger: '#shopify-section-template--24042611966238__power_section_RCBAqi .ss-content-wrapper',
      start: 'top top',
      end: '70% bottom',
      scrub: 2,
      markers: false,
    },
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0,
    duration: 1
  });

  }




  
/*------- FOOTER ANIMATION --------*/
if (window.innerWidth > 1025) {
  gsap.fromTo(
    ".template-index .shopify-section-group-footer-group",
    {
      filter: "blur(10px)",
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: ".template-index .shopify-section-group-footer-group",
        start: "top bottom",    // when the footer hits the bottom of the viewport
        end: "top 40%",         // when the footer reaches the center
        scrub: true,
        markers: false,         // set to true if you want to debug
      },
      filter: "blur(0px)",
      opacity: 1,
      ease: "none",
    }
  );


}


  
});



/* add active link to custom liquid category filter on blog page */
  
    document.addEventListener('DOMContentLoaded', function() {
    const categoryLinks = document.querySelectorAll('#category-links .category-link');

    function setActiveLink() {
        const currentPath = window.location.pathname;
        
        categoryLinks.forEach(function(link) {
            if (link.getAttribute('href') === currentPath) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    // Set the active link when the page loads
    setActiveLink();

    // Optional: If you want the active class to change on click without reloading the page
    categoryLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            categoryLinks.forEach(function(l) {
                l.classList.remove('active');
            });
            this.classList.add('active');
        });
    });
});








/*------ ABOUT PAGE TO KNOWN GRAPHIC ---------*/


gsap.registerPlugin(ScrollTrigger);

gsap.to(".meet-the-founder-graphic.decor-position--bottom-left", {
  x: 0,
  ease: "none",
  scrollTrigger: {
    trigger: ".meet-the-founders",
    start: "top bottom",
    end: "bottom bottom",
    scrub: 2
  }
});






/*----- HORIZONTAL SCROLLING PRODUCT GALLERY  -----*/
  
  gsap.registerPlugin(ScrollTrigger);

gsap.to(".horizontal-product-gallery .ss-col-12", {
  xPercent: -51,
  ease: "power2.out", // smoother transition
  scrollTrigger: {
    trigger: ".horizontal-product-gallery",
    start: "top top",
    end: "bottom bottom",
    markers: false,
    scrub: 2, 
  },
});


/*---
  gsap.registerPlugin(ScrollTrigger);

gsap.to(".blog .blog__posts", {
  xPercent: -151,
  ease: "power2.out", // smoother transition
  scrollTrigger: {
    trigger: ".blog",
    start: "top top",
    end: "bottom bottom",
    markers: false,
    scrub: 2, 
  },
});
----*/







/* HORIZONTAL SCROLLING PLAY

window.addEventListener("load", () => {
  gsap.registerPlugin(ScrollTrigger);

  const track = document.querySelector(".horizontal-product-gallery .ss-col-12");
  const products = gsap.utils.toArray(".horizontal-product-gallery .ss-grid__item--product");
  const scrollAmount = track.scrollWidth - window.innerWidth;

  gsap.to(track, {
    x: () => `-${scrollAmount}px`,
    ease: "none",
    scrollTrigger: {
      trigger: ".horizontal-product-gallery",
      start: "top top",
      end: () => `+=${scrollAmount}`,
      pin: true,
      scrub: 1,
      markers: false
    }
  });
});

*/







  
  /*----- HORIZONTAL BLOG GALLERY 
if (window.innerWidth > 989) {
  const blogPosts = document.querySelector(".blog .blog__posts");

  if (blogPosts) {
    function getBlogScrollAmount() {
      const blogWidth = blogPosts.scrollWidth;
      return -(blogWidth - window.innerWidth);
    }

    const blogTween = gsap.to(blogPosts, {
      x: getBlogScrollAmount,
      duration: 3,
      ease: "none",
    });

    ScrollTrigger.create({
      trigger: ".blog",
      start: "top 25%",
      end: () => `+=${getBlogScrollAmount() * -1}`,
      pin: true,
      animation: blogTween,
      scrub: 2,
      invalidateOnRefresh: true,
      markers: false,
    });
  }
}
---*/





/*------ MAIN CONTENT BLUR 

document.addEventListener('DOMContentLoaded', function() {
  const menuDrawer = document.querySelector('.menu-drawer-container');
  const mainContent = document.querySelector('#MainContent');

  if (menuDrawer && mainContent) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if (menuDrawer.classList.contains('menu-opening')) {
            mainContent.classList.add('blurred-content');
          } else {
            mainContent.classList.remove('blurred-content');
          }
        }
      });
    });

    observer.observe(menuDrawer, { attributes: true });
  }
});
------*/






/*     Sticky Text Animation     

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  const firstHeading = document.querySelector(".first-heading");
  const secondHeading = document.querySelector(".second-heading");
  const thirdHeading = document.querySelector(".third-heading");

  const totalScrollHeight = 300; // 300vh total
  const sectionDivisions = totalScrollHeight / 3; // Divide evenly

  // ScrollTriggers for the headings
  ScrollTrigger.create({
    trigger: ".sticky-text-animation",
    start: "top 50%", 
    end: "top+=23% top", // 33% scroll
    onEnter: () => firstHeading.classList.add("active"),
    onLeave: () => firstHeading.classList.remove("active"),
    onEnterBack: () => firstHeading.classList.add("active"),
    onLeaveBack: () => firstHeading.classList.remove("active"),
    scrub: true,
  });

  ScrollTrigger.create({
    trigger: ".sticky-text-animation",
    start: "top+=23% top", 
    end: "top+=46% top", // 66% scroll
    onEnter: () => secondHeading.classList.add("active"),
    onLeave: () => secondHeading.classList.remove("active"),
    onEnterBack: () => secondHeading.classList.add("active"),
    onLeaveBack: () => secondHeading.classList.remove("active"),
    scrub: true,
  });

  ScrollTrigger.create({
    trigger: ".sticky-text-animation",
    start: "top+=46% top", 
    end: "bottom top", // Keep until the section leaves
    onEnter: () => thirdHeading.classList.add("active"),
    onLeave: () => thirdHeading.classList.remove("active"),
    onEnterBack: () => thirdHeading.classList.add("active"),
    onLeaveBack: () => thirdHeading.classList.remove("active"),
    scrub: true,
  });

  // Ensure the first heading stays active when scrolling back up past the section
  ScrollTrigger.create({
    trigger: ".sticky-text-animation",
    start: "top top", // When we reach the very top of the section
    end: "top+=1 top", // Tiny offset to keep first heading active on scroll-up
    onEnterBack: () => firstHeading.classList.add("active"),
    //onLeaveBack: () => firstHeading.classList.remove("active"),
    toggleActions: "play none none reverse", // Keeps it active when scrolling up
  });

  // Ensure the last heading stays active when scrolling down past the section
  ScrollTrigger.create({
    trigger: ".sticky-text-animation",
    start: "bottom top",
    end: "bottom+=1 top", // Tiny offset to keep last heading active
    onEnterBack: () => thirdHeading.classList.add("active"),
    onLeaveBack: () => thirdHeading.classList.remove("active"),
    toggleActions: "play none none reverse",
  });
});

 */






